import * as React from 'react';
import clsx from 'clsx';
import { useTranslator } from '@gandi/translate';
import Dots from './Dots';
import Products from './Products';
import { jsx as _jsx } from "react/jsx-runtime";
var styles = {
  "root": "Spinner-root_10wsp",
  "centered": "Spinner-centered_THCYZ"
};
function Spinner({
  name = 'products',
  variant,
  centered,
  children,
  className,
  ...extraProps
}) {
  const {
    __
  } = useTranslator();
  const rootClasses = clsx(styles.root, centered && styles.centered, className);
  const title = typeof children === 'string' ? children : __('Loading...');
  if (name === 'dots') {
    return /*#__PURE__*/_jsx(Dots, {
      title: title,
      className: rootClasses,
      ...extraProps
    });
  }
  return /*#__PURE__*/_jsx(Products, {
    variant: variant,
    title: title,
    className: rootClasses,
    ...extraProps
  });
}
export default Spinner;